import { FormGroup } from "@angular/forms";
import { Store } from "@ngrx/store";
import {debounceTime, filter, take} from "rxjs";
import { FormListeners } from "../../../models/beans/form-listeners.abstract";
import { Revisione53State } from "../../../store/revisione53.reducers";
import { Revisione53DatiBusinessSelectors } from "../../../store/selectors/dati-business.selectors";
import { SezIIAccertamentoHelpers } from "app/features/revisione53/features/sez-II-accertamento/shared/helpers/sez-II-accertamento.helpers";
import { revisione53DatiSecondariSelectors } from "../../../store/selectors/dati-secondari.selectors";
import {Utilities} from "@core/helpers/utilities";

export class SezIIAccertamentoFormListeners extends FormListeners {

    private store: Store<Revisione53State>;

    constructor(form: FormGroup, store: Store<Revisione53State>) {
        super(form);
        this.store = store;
    }

    setListeners(): void {
        this.my_CkMutualPrevII();
        this.my_CkProposteII();
        this.my_CkProvvedimendoDiII();
        this.my_ComuneSedeLegaleII();
        this.my_DataCompilazII();
        this.my_ProvinciaSedeLegaleII();
        this.my_RappresentanteCoopCognomeII();
        this.my_RappresentanteCoopNomeII();
        this.my_RappresentanteCoopSceltaII();
        this.my_RegimeDerogatorioProvalenzaII();
        this.my_SezEnteII();
    }

    private my_CkMutualPrevII(): void {
        const my_PosizAlboEntiIIControl = this.form.get('my_SezioneII__Accertamento.my_PosizAlboEntiII');

        this.form.get('my_SezioneII__Accertamento.my_CkMutualPrevII').valueChanges.pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME)).subscribe(my_CkMutualPrevII => {
            if (my_CkMutualPrevII === '3') {
                my_PosizAlboEntiIIControl.setValue('Non iscritta');
            }

            else if (my_CkMutualPrevII != '3' && my_PosizAlboEntiIIControl.value === 'Non iscritta') {
                my_PosizAlboEntiIIControl.setValue('');
            }
        })
    }

    private my_CkProposteII(): void {
        this.form.get('my_SezioneII__Accertamento.my_CkProposteII').valueChanges.pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME)).subscribe(my_CkProposteII => {
            if (my_CkProposteII != '2') {
                this.form.get('my_SezioneII__Accertamento.my_CkProvvedimendoDiII').setValue('');
                this.form.get('my_SezioneII__Accertamento.my_CkNominaLiqII').setValue('');
            }
            else if (my_CkProposteII != '') {
                if (my_CkProposteII === '5') {
                    this.form.get('my_SezioneII__Accertamento.my_CkProvvedimendoDiII').setValue('8');
                }
                else {
                    this.form.get('my_SezioneII__Accertamento.my_CkProvvedimendoDiII').setValue('');
                }
            }
        })
    }

    private my_CkProvvedimendoDiII(): void {
        this.form.get('my_SezioneII__Accertamento.my_CkProvvedimendoDiII').valueChanges.pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME)).subscribe(my_CkProvvedimendoDiII => {
            if (my_CkProvvedimendoDiII != '3') {
                this.form.get('my_SezioneII__Accertamento.my_CkNominaLiqII').setValue('');
            }
        })
    }

    private my_ComuneSedeLegaleII(): void {
        this.form.get('my_SezioneII__Accertamento.my_ComuneSedeLegaleII').valueChanges.pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME)).subscribe(my_ComuneSedeLegaleII => {
            this.store.select(Revisione53DatiBusinessSelectors.getComune(my_ComuneSedeLegaleII)).pipe(
                take(1),
                filter(codComune => !!codComune))
                .subscribe(comune => {
                    this.form.get('my_SezioneII__Accertamento.my_DescComuneSedeLegaleII').setValue(comune.Nome_comune);
                })
        })
    }

    private my_DataCompilazII(): void {
        this.form.get('my_SezioneII__Accertamento.my_DataCompilazII').valueChanges.pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME)).subscribe(my_DataCompilazII => {
            SezIIAccertamentoHelpers.calcolaDataScadenzaAccertamento(this.store);
        })
    }

    private my_ProvinciaSedeLegaleII(): void {
        const my_ProvinciaSedeLegaleII = this.form.get('my_SezioneII__Accertamento.my_ProvinciaSedeLegaleII');

        my_ProvinciaSedeLegaleII.valueChanges.pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME)).subscribe(my_ProvinciaSedeLegaleII => {
            this.store.select(Revisione53DatiBusinessSelectors.getProvincia(my_ProvinciaSedeLegaleII)).pipe(
                take(1),
                filter(codProvincia => !!codProvincia))
                .subscribe(provincia => {
                    this.form.get('my_SezioneII__Accertamento.my_DescProvinciaSedeLegaleII').setValue(provincia.Nome);
                })
        })
    }

    private my_RappresentanteCoopCognomeII(): void {
        const my_RappresentanteCoopCognomeII = this.form.get('my_SezioneII__Accertamento.my_RappresentanteCoopCognomeII');
        const my_RappresentanteCoopNomeII = this.form.get('my_SezioneII__Accertamento.my_RappresentanteCoopNomeII').value;

        my_RappresentanteCoopCognomeII.valueChanges.pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME)).subscribe(my_RappresentanteCoopCognomeII => {
            let firmaLegale = my_RappresentanteCoopNomeII + ' ' + my_RappresentanteCoopCognomeII;

            this.form.get('my_SezioneII__Accertamento.my_FirmaLegaleRappresentanteII').setValue(firmaLegale);
        })
    }

    private my_RappresentanteCoopNomeII(): void {
        const my_RappresentanteCoopNomeII = this.form.get('my_SezioneII__Accertamento.my_RappresentanteCoopNomeII');
        const my_RappresentanteCoopCognomeII = this.form.get('my_SezioneII__Accertamento.my_RappresentanteCoopCognomeII').value;

        my_RappresentanteCoopNomeII.valueChanges.pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME)).subscribe(my_RappresentanteCoopNomeII => {
            let firmaLegale = my_RappresentanteCoopNomeII + ' ' + my_RappresentanteCoopCognomeII;

            this.form.get('my_SezioneII__Accertamento.my_FirmaLegaleRappresentanteII').setValue(firmaLegale);
        })
    }

    private my_RappresentanteCoopSceltaII(): void {
        this.form.get('my_SezioneII__Accertamento.my_RappresentanteCoopSceltaII').valueChanges.pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME)).subscribe(my_RappresCoopSceltaII => {
            if (my_RappresCoopSceltaII != '') {
                this.store.select(revisione53DatiSecondariSelectors.getAbLocaleRappresentante(my_RappresCoopSceltaII)).pipe(
                    take(1)
                ).subscribe(rappresCoopScelta => {
                    if (rappresCoopScelta) {
                        this.form.get('my_SezioneII__Accertamento.my_RappresentanteCoopNomeII').setValue(rappresCoopScelta.nome);
                        this.form.get('my_SezioneII__Accertamento.my_RappresentanteCoopCognomeII').setValue(rappresCoopScelta.cognome);
                        this.form.get('my_SezioneII__Accertamento.my_RappresentanteCoopCodFiscII').setValue(rappresCoopScelta.cod_fiscale);
                    }
                })
            }
            else {
                this.form.get('my_SezioneII__Accertamento.my_RappresentanteCoopNomeII').setValue('');
                this.form.get('my_SezioneII__Accertamento.my_RappresentanteCoopCognomeII').setValue('');
                this.form.get('my_SezioneII__Accertamento.my_RappresentanteCoopCodFiscII').setValue('');
            }
        })
    }

    private my_RegimeDerogatorioProvalenzaII(): void {
        this.form.get('my_SezioneII__Accertamento.my_RegimeDerogatorioProvalenzaII').valueChanges.pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME)).subscribe(my_RegimeDerogatorioProvalenzaII => {
            this.form.get('my_SezioneII__Accertamento.my_DescRegimeDerogatorioPrevalenzaII').setValue(my_RegimeDerogatorioProvalenzaII);

            if (my_RegimeDerogatorioProvalenzaII === "1" || my_RegimeDerogatorioProvalenzaII === "1") {
                this.form.get('my_SezioneII__Accertamento.my_CkRientranteInRegimeDerogatorioII').setValue('0');
            }
            else {
                this.form.get('my_SezioneII__Accertamento.my_CkRientranteInRegimeDerogatorioII').setValue('1');
            }

        })
    }

    private my_SezEnteII(): void {
        this.form.get('my_SezioneII__Accertamento.my_SezEnteII').valueChanges.pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME)).subscribe(my_SezEnteII => {
            this.store.select(Revisione53DatiBusinessSelectors.getSezioneAlboNazEntiCoopSpec(my_SezEnteII)).pipe(
                take(1)
            ).subscribe(sezEnte => {
                if (sezEnte) {
                    this.form.get('my_SezioneII__Accertamento.my_DescSezEnteII').setValue(sezEnte.sezioneAlboNazEntiCoop);
                }
            })
        })
    }

}
